<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Editer votre profil</h4>
    </div>
    <div class="card-content" v-if="updates">
      <form>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Nom et prénom"
                      placeholder="Nom et prénom"
                      v-model="updates.displayName">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Entreprise"
                      :disabled="true"
                      placeholder="Entreprise"
                      :value="company ? company.name : ''">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Téléphone"
                      placeholder="Numéro de téléphone"
                      v-model="updates.phoneNumber">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Email"
                      :disabled="true"
                      placeholder="Email"
                      :value="updates.email">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input type="text"
                      label="Ville"
                      placeholder="Ville"
                      v-model="updates.city">
            </fg-input>
          </div>
          <div class="col-md-4">
            <fg-input type="text"
                      label="Pays"
                      placeholder="Pays"
                      v-model="updates.country">
            </fg-input>
          </div>
          <div class="col-md-4">
            <fg-input type="number"
                      label="Code Postal"
                      placeholder="ZIP Code"
                      v-model="updates.postalCode">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-8">
            <div class="form-group">
              <label>Bio</label>
              <textarea rows="5" class="form-control border-input"
                        placeholder="Here can be your description"
                        v-model="updates.bio">

              </textarea>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Photo</label>
              <img style="cursor: pointer;" @click="$refs.input.click()" class="avatar border-white" :src="updates.photoURL ? updates.photoURL : 'static/img/default-avatar.png'" alt="...">
              <input
                v-show="false"
                ref="input"
                accept="image/*"
                type="file"
                @change="fileSelected">
            </div>
          </div>
        </div>
        <div class="text-center">
          <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="update">
            Mettre à jour
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
    <div class="card-content" v-else>
      Chargement...
    </div>
    <div class="card-footer" v-if="this.uploading">
      <p-progress  :value="this.uploading"></p-progress>
    </div>
  </div>
</template>
<script>
  import firebase from 'firebase'
  import PProgress from 'src/components/UIComponents/Progress.vue'
  import { mapGetters } from 'vuex'

  function uploadFile (file, to, success, progress, error) {
    const metadata = {
      cacheControl: 'public,max-age=3600',
      contentType: file.type,
      customMetadata: {
        owner: firebase.auth().currentUser.uid
      }
    }
    const upload = firebase.storage()
      .ref(to)
      .put(file, metadata)
    upload.on('state_changed', (snapshot) => {
      progress((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
    }, (err) => {
      error(err)
    }, (res) => {
      success(upload.snapshot.downloadURL)
    })
  }

  export default {
    data () {
      return {
        uploading: 0,
        updates: null
      }
    },
    computed: {
      ...mapGetters('profiles', {
        profile: 'mine'
      }),
      ...mapGetters('companies', {
        company: 'mine'
      }),
      user () {
        return firebase.auth().currentUser
      }
    },
    watch: {
      profile (profile) {
        this.updates = {
          ...profile
        }
      }
    },
    mounted () {
      this.updates = {
        ...this.profile
      }
    },
    methods: {
      fileSelected (ev) {
        const file = ev.target.files[0]
        this.file = file
        this.$set(this.updates, 'photoURL', URL.createObjectURL(file))
      },
      update () {
        if (this.file) {
          uploadFile(this.file, `/users/${this.user.uid}/${this.file.name}`,
            (url) => {
              this.updates.photoURL = url
              this.uploading = 0
              this.file = null
              this.updateProfile()
            }, (progress) => {
              this.uploading = progress
            }, (err) => {
              console.error(err)
              this.uploading = 0
              this.$notify({
                component: {
                  template: `<span>Erreur lors de l'upload de votre photo de profil</span>`
                },
                icon: 'ti-alert',
                horizontalAlign: 'center',
                verticalAlign: 'bottom',
                type: 'warning'
              })
            })
        } else {
          this.updateProfile()
        }
      },
      updateProfile () {
        firebase.auth().currentUser.updateProfile(this.updates)
          .then(() => {
            console.log('profile updated')
          }).catch((error) => {
            console.error(error)
            this.$notify({
              component: {
                template: `<span>Erreur lors de la mise à jour de votre profil</span>`
              },
              icon: 'ti-alert',
              horizontalAlign: 'center',
              verticalAlign: 'bottom',
              type: 'warning'
            })
          })
        firebase.firestore().collection('users').doc(this.user.uid).update(this.updates)
          .then(() => {
            this.$notify({
              component: {
                template: `<span>Vos informations ont correctement été mises à jour</span>`
              },
              icon: 'ti-check',
              horizontalAlign: 'center',
              verticalAlign: 'bottom',
              type: 'success'
            })
          }).catch((error) => {
            console.error('error updating profile', error)
            this.$notify({
              component: {
                template: `<span>Erreur lors de la mise à jour de votre profil</span>`
              },
              icon: 'ti-alert',
              horizontalAlign: 'center',
              verticalAlign: 'bottom',
              type: 'warning'
            })
          })
      }
    },
    components: {
      PProgress
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/User/UserProfile/EditProfileForm.vue